import React from 'react';
import { Text, View, Image, Dimensions, Pressable } from "react-native";
import { Rating } from 'react-native-ratings';
import { CampReviewRecord } from '../../../../interface/Review';

const WIDTH = Dimensions.get('window').width * 0.3

const formatDateLabel = (value: any) => {
    if (!value) return '';
    const date = value?.toDate ? value.toDate() : new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString(undefined, { month: 'short', year: 'numeric' });
};

const getReviewerAddress = (review: CampReviewRecord) => {
    const author = review.author || {};
    return [author.city, author.state, author.country].filter(Boolean).join(', ');
};

const getDisplayName = (review: CampReviewRecord) => {
    const author = review.author || {};
    if (author.displayName) return author.displayName;
    const fromNames = [author.firstName, author.lastName].filter(Boolean).join(' ').trim();
    return fromNames || 'SnapCamp Parent';
};

const CampPageReviews = ({ review }: { review: CampReviewRecord }) => {
    const comment = review.comment || '';
    const dateLabel = formatDateLabel(review.createdAt);
    const reviewerAddress = getReviewerAddress(review);
    const avatarUri = review.author?.avatarUrl;

    return (
        <View style={{ flexDirection: 'column', marginBottom: 36, width: WIDTH, minHeight: 150 }}>
            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
                <Image
                    source={{ uri: avatarUri || 'https://via.placeholder.com/100x100.png?text=SC' }}
                    style={{ width: 50, height: 50, borderRadius: 25, marginRight: 15 }}
                />
                <View style={{ flexDirection: 'column' }}>
                    <Text style={{ fontSize: 16, fontWeight: 500 }}>{getDisplayName(review)}</Text>
                    {reviewerAddress ? <Text style={{ fontSize: 14 }}>{reviewerAddress}</Text> : null}
                </View>
            </View>

            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
                <Rating
                    type='star'
                    fractions={1}
                    startingValue={Number(review.rating || 0)}
                    imageSize={10}
                    readonly
                    style={{ alignItems: 'flex-start' }}
                />
                {dateLabel ? <Text style={{ fontSize: 13, fontWeight: 500 }}>{' \u2022 ' + dateLabel}</Text> : null}
            </View>

            <Text style={{ fontSize: 16, marginBottom: 10 }}>
                {
                    comment.length > 150
                        ? comment.substring(0, 147) + "..."
                        : comment
                }
            </Text>

            {
                comment.length > 150 &&
                <Pressable>
                    <Text style={{ fontSize: 17, fontWeight: 500, textDecorationLine: 'underline' }}>
                        Show more
                    </Text>
                </Pressable>
            }
        </View>
    );
};

export default CampPageReviews;